import { executeRequest, Request } from '@jfs/network'
import { createPaymentLinkParser } from '../network/parsers/CreatePaymentLinkParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = createPaymentLinkParser(data)
  return respData
}

const createPaymentLinkRequest = (req: any, tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.createPaymentLink,
    method: 'POST',
    body: req,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data?.data)
  })
}

export { createPaymentLinkRequest }
